import React, { useState } from 'react';
import { crearComentario, getComentariosPorTarea } from '../services/tareasService';
import ReusableTable from './ReusableTable';
import { formatearBogota } from '../utils/fecha';
import './styles/GestionarPermisosModal.css';

const ComentarioButton = ({ tareaId }) => {
  // Estado para crear comentario
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [comentario, setComentario] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Estado para ver comentarios
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [comentarios, setComentarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorView, setErrorView] = useState('');

  // Abrir modal para crear comentario
  const handleOpenCreateModal = () => {
    setIsCreateModalOpen(true);
    setError('');
    setSuccess('');
  };

  // Cerrar modal de crear comentario
  const handleCloseCreateModal = () => {
    setIsCreateModalOpen(false);
    setComentario('');
    setError('');
    setSuccess('');
  };

  // Enviar comentario
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!comentario.trim()) {
      setError('El comentario no puede estar vacío');
      return;
    }
    if (comentario.length > 500) {
      setError('El comentario no puede exceder los 500 caracteres');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const response = await crearComentario(tareaId, comentario);
      if (response.success) {
        setSuccess('Comentario creado exitosamente');
        setComentario('');
        setTimeout(() => {
          handleCloseCreateModal();
        }, 2000);
      } else {
        setError(response.message);
      }
    } catch (err) {
      setError('Error al crear el comentario');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Abrir modal para ver comentarios
  const handleOpenViewModal = async () => {
    setIsViewModalOpen(true);
    setErrorView('');
    setLoading(true);
    const response = await getComentariosPorTarea(tareaId);
    if (response.success) {
      setComentarios(response.data);
    } else {
      setErrorView(response.message);
    }
    setLoading(false);
  };

  // Cerrar modal de ver comentarios
  const handleCloseViewModal = () => {
    setIsViewModalOpen(false);
    setComentarios([]);
    setErrorView('');
  };

  // Columnas para la tabla de comentarios
  const columns = [
    { key: 'usuarioCreacionNombre', label: 'Usuario' },
    { key: 'comentario', label: 'Comentario' },
    { 
      key: 'fechaCreacion', 
      label: 'Fecha Creación',
      formatter: (date) => formatearBogota(date)
    }
  ];

  return (
    <>
      <button 
        onClick={handleOpenCreateModal}
        className="create-btn"
        style={{ padding: '4px 12px', fontSize: '14px', marginRight: 6 }}
      >
        Comentar
      </button>
      <button 
        onClick={handleOpenViewModal}
        className="view-btn"
        style={{ padding: '4px 12px', fontSize: '14px' }}
      >
        Ver comentarios
      </button>

      {/* Modal para crear comentario */}
      {isCreateModalOpen && (
        <div className="modal-permisos-backdrop">
          <div className="modal-permisos-container">
            <div className="modal-permisos-header">
              <h2 className="modal-permisos-title">Crear Comentario</h2>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-permisos-body">
                <div className="form-group">
                  <label htmlFor="comentario">Comentario:</label>
                  <textarea
                    id="comentario"
                    value={comentario}
                    onChange={(e) => setComentario(e.target.value)}
                    maxLength={500}
                    rows={4}
                    style={{
                      width: '100%',
                      padding: '8px',
                      marginTop: '8px',
                      borderRadius: '4px',
                      border: '1px solid #e0e0e0'
                    }}
                    placeholder="Escribe tu comentario aquí (máximo 500 caracteres)"
                  />
                  <small style={{ color: '#888', display: 'block', marginTop: '4px' }}>
                    {comentario.length}/500 caracteres
                  </small>
                </div>
                {error && <div style={{ color: 'red', marginTop: '8px' }}>{error}</div>}
                {success && <div style={{ color: 'green', marginTop: '8px' }}>{success}</div>}
              </div>
              <div className="modal-permisos-actions">
                <button 
                  type="button" 
                  onClick={handleCloseCreateModal} 
                  className="modal-permisos-btn cancelar"
                >
                  Cancelar
                </button>
                <button 
                  type="submit" 
                  className="modal-permisos-btn guardar"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal para ver comentarios */}
      {isViewModalOpen && (
        <div className="modal-permisos-backdrop">
          <div className="modal-permisos-container" style={{ minWidth: 400, maxWidth: 600 }}>
            <div className="modal-permisos-header" style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <h2 className="modal-permisos-title" style={{ margin: 0 }}>Comentarios de la tarea</h2>
              <button 
                type="button" 
                onClick={handleCloseViewModal} 
                className="modal-permisos-btn close-x"
                aria-label="Cerrar"
              >
                ×
              </button>
            </div>
            <div className="modal-permisos-body">
              {loading && <p>Cargando comentarios...</p>}
              {errorView && <div style={{ color: 'red', marginTop: '8px' }}>{errorView}</div>}
              {!loading && !errorView && (
                <ReusableTable 
                  data={comentarios} 
                  columns={columns}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ComentarioButton;